// Material UI
import { IconButton, makeStyles } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useRef, useLayoutEffect, useReducer } from "react";
import { Palette } from "../AppConfig";
import CloseIcon from "@material-ui/icons/Close";
import { useWindowDimensions } from "../helper/Helper";
import { BaseURL } from "./Common";
import { updateAPP, toggleAPP, DESIGNER_PAGE } from "../redux_store/appState";
import {} from "react";
import { createPortal } from "react-dom";

// Components requires touch up to styling
// Currently messy
const useStyles = makeStyles({
    root: {
        backgroundColor: "white",
        overflowX: "scroll",
        scrollBehavior: "smooth",
    },
    scrollBar: {
        position: "fixed",
        right: "0px",
        display: "flex",
        flex: 1,
        justifyContent: "end",
        // position: "sticky",
        top: 105,
        height: 0,
        scrollBehavior: "smooth",
    },
    hideBar: {
        visibility: "hidden !important",
        transition: "all 0.1s ease",
        width: 0,
    },
    closeButton: {
        display: "flex",
        justifyContent: "end",
        position: "absolute",
        right: "27px",
        "& > *": {
            color: Palette.Lysaght.DarkBlue,
        },
    },
    container: {
        padding: "10px 10px 10px 30px",
        transition: "all 0.1s ease",
        width: 400,
        opacity: 1,
        textAlign: "left",
        "& > h1": {
            marginTop: "0px",
            fontWeight: "bold",
            fontSize: "40px",
            color: Palette.Lysaght.LightBlue,
        },
        "& > h2": {
            marginTop: 0,
            color: Palette.Lysaght.DarkBlue,
        },
        "& > h3": {
            color: "black",
        },
    },
    containerClose: {
        padding: "10px 10px 10px 30px",
        transition: "all 0.1s ease",
        width: 0,
        opacity: 0,
        padding: 0,
        overflow: "hidden",
        textAlign: "left",
        "& > h1": {
            marginTop: "0px",
            fontWeight: "bold",
            fontSize: "40px",
            color: Palette.Lysaght.LightBlue,
        },
        "& > h2": {
            marginTop: 0,
            color: Palette.Lysaght.DarkBlue,
        },
        "& > h3": {
            color: "black",
        },
    },
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "repeat( auto-fit, minmax(200px, 1fr) )",
    },
    gridItem: {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        padding: "0px 5px",
    },
    styledImage: {
        width: 380,
        height: 215,
        "&:hover": {
            cursor: "pointer",
        },
    },
});

// Open window with appended items
const NewWindow = ({ children }) => {
    const div = useRef(document.createElement("div"));

    useLayoutEffect(() => {
        const external = window.open("", "", "width=800,height=600,left=400,top=200");

        external.document.body.appendChild(div.current);

        return () => external.close();
    }, []);

    return createPortal(children, div.current);
};

// Convert to Base64
function toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
}

export function BSL_HelpLysaght() {
    const dispatch = useDispatch();
    const page = useSelector((state) => state.app.page);
    const main_page = useSelector((state) => state.app.MAIN_PAGE);
    const help_open = useSelector((state) => state.app.help_open);
    const help_section = useSelector((state) => state.app.help_section);
    const manufacturer = useSelector((state) => state.app.manufacturer);
    const { height } = useWindowDimensions();
    const classes = useStyles();

    const [open, toggle] = useReducer((x) => !x, false);
    const [renderImage, setRenderImage] = React.useState();

    //document refs for scrolling
    const blockingRef = useRef(null);
    const jobtypeRef = useRef(null);

    let width = 0;

    const handleClose = () => {
        // setState({ ...state, helpOpen: false });
        dispatch(toggleAPP("help_open", false)).then(() => {
            dispatch(updateAPP("help_section", ""));
        });
    };

    // Render side-blocking image for pop-up.
    if (!renderImage && open) {
        if (window.brand === "Fielders") {
            toDataURL(BaseURL("images/Blocking-Images/1625(F).png"), function (dataUrl) {
                setRenderImage(dataUrl);
            });
        } else {
            toDataURL(BaseURL("images/Blocking-Images/1625.png"), function (dataUrl) {
                setRenderImage(dataUrl);
            });
        }
    }

    useEffect(() => {
        if (help_section) {
            setTimeout(() => {
                switch (help_section) {
                    case "blocking":
                        if (blockingRef?.current) {
                            blockingRef.current.scrollIntoView({
                                block: "start",
                                inline: "center",
                                behavior: "smooth",
                                alignToTop: true,
                            });
                        }
                        break;
                    case "jobtype":
                        if (jobtypeRef?.current)
                            jobtypeRef.current.scrollIntoView({
                                block: "start",
                                inline: "center",
                                behavior: "smooth",
                                alignToTop: true,
                            });
                        break;
                    default:
                        break;
                }
            }, 350);
        }
    }, [help_section]);

    useEffect(() => {
        if (main_page.page === "Orders" && help_open) {
            handleClose();
        }
    }, [main_page.page]);

    if (help_open === true && width === 0) {
        width = 400;
    }
    if (help_open === false && width === 400) {
        width = 0;
    }

    const renderHelp = () => {
        if (page === DESIGNER_PAGE) {
            return HelpNewJobs();
        }
        switch (main_page?.page) {
            case "Recall":
                return HelpJobs();
            case "New":
                return HelpNewJobs();
            default:
                return <></>;
        }
    };

    const HelpJobs = () => (
        <>
            <h2>New Job</h2>
            <p>
                A “job” in {manufacturer?.SoftwareName} represents a specific variation of a project, whether or not it
                has been designed, quoted or ordered. To create a brand new job, click New Job…, or to produce a new
                variation of an existing job click the menu (…) button beside that quote and choose Duplicate Job from
                the menu.
            </p>
            <h2>Jobs List</h2>
            <p>
                You can search and filter the list of your existing jobs in many different ways according to your needs.
                Choose Active or Archived to view the applicable jobs. The numbers beside each option indicate the total
                number of jobs in each category. Use the search field to instantly filter items by project or customer
                name, suburb, structure type, quote number or status.
            </p>
            <h3>Job Statuses</h3>

            <p>
                Each job has a current status which you can see and change easily. To change a job’s status, click its
                existing status and choose a new option from the menu provided.
            </p>
            <div style={{ display: "flex" }}>
                <div>
                    <p
                        style={{
                            backgroundColor: "#E9EEf6",
                            borderRadius: 99,
                            color: Palette.Lysaght.DarkBlue,
                            margin: "auto",
                            padding: "2px 10px",
                            border: `1px solid ${Palette.Lysaght.DarkBlue}`,
                        }}
                    >
                        Quote
                    </p>
                </div>
                <p style={{ margin: 0, paddingLeft: 10 }}>
                    <span style={{ fontWeight: "bold" }}>LEFT:</span> The job status is shown in a colour-coded tag. To
                    change the status of a job, click the status tag and choose a new option from the menu.
                </p>
            </div>
            <h3>Pinning Job to the top</h3>
            <p>
                You can pin jobs to the top of the list to help make them easier to find in the future. To pin a job,
                hover over it, then click <img alt="" src={BaseURL("images/ly-pin.svg")} />, or choose Pin Job To Top
                from the job menu.
            </p>

            <p>
                To unpin a job, click <img alt="" src={BaseURL("images/ly-pin-set.svg")} /> beside the job, or deselect
                Pin Job To Top from the job menu.
            </p>

            <h3>Grid View</h3>
            <p>To view jobs in grid view, press the Grid View option in the top right of the window:</p>
            <div style={{ display: "flex" }}>
                <img
                    style={{ border: `1px solid ${Palette.Lysaght.DarkBlue}` }}
                    alt=""
                    src={BaseURL("images/ly-view-switch.svg")}
                />
                <p style={{ paddingLeft: 10 }}>
                    <span style={{ fontWeight: "bold" }}>LEFT:</span> The view switch with Grid View selected.
                </p>
            </div>
            <p>
                When in grid view, jobs are shown as large cards, with generous thumbnail images. This mode is useful to
                find a given project visually based on design factors such as shape or colour. To edit a job in Grid
                View, click the thumbnail on the card, or choose Edit from the job menu.
            </p>
        </>
    );

    const HelpNewJobs = () => (
        <>
            <h2>Customer Details</h2>
            <p>
                You can enter as much or as little about your customer as you like. The only information you must supply
                is a unique project name to help identify this project in {manufacturer?.SoftwareName}. Feel free to set
                this to any value that suits you best—it’s for your use.
            </p>
            <p>You can add or change any of this information in the future if necessary.</p>
            <h2>Job Details</h2>
            <p>
                In order to start a new job, you’ll need to know the location of the site, which is used to validate
                engineering against prevailing wind conditions.
            </p>
            <p>You can change any of this information in the future if necessary.</p>
            <h3 ref={jobtypeRef}>Importance Level</h3>
            <p style={{ fontWeight: "bold" }}>Importance Level 1</p>
            <p>
                Any structure that is freestanding and at least 1 meter away from any other existing structure. This
                structure will be designed as <b>Importance L1</b>.
            </p>
            <p style={{ fontWeight: "bold" }}>Importance Level 2</p>

            <p>
                Any structure that is freestanding and less than 1 meter away from any other existing structure or
                attached to an existing structure. This structure will be designed <b>Importance L2</b>.
            </p>
            <p>
                All structures designed for a Commercial site, select <b>Importance L2</b>.
            </p>
            <p style={{ fontWeight: "bold" }}>Importance Level 3</p>
            <p>
                All structures designed for a School site or Public building i.e. Hall, Park etc, select{" "}
                <b>Importance L3</b>.
            </p>

            <p>All definitions are as per NCC Volume 2 3.0.3 (c) (i) (A).</p>

            <h3 ref={blockingRef}>Blocking</h3>

            <p>
                The number of sides blocked is an essential part of the formula {manufacturer?.SoftwareName} uses to
                calculate the uplift wind pressure and in selecting the correct members to carry those wind loads, so
                make sure you’re selecting the correct value.
            </p>
            <p>
                You should consider nearby structures on either side of a fence or wall when determining the correct
                blocking to use. The more sides blocked, the higher the wind uplift unless completely blocked on all
                four sides (a.k.a. 4B).
            </p>
            <p>
                If you’re uncertain which option to choose, refer to a suitable qualified engineer, or choose the higher
                number of sides blocked.
            </p>
            <div className={classes.gridItem}>
                <div className={classes.styledImage}>
                    {window.brand === "Fielders" ? (
                        <img
                            onClick={toggle}
                            style={{ width: "300px", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1625(F).png")}
                        />
                    ) : (
                        <img
                            onClick={toggle}
                            style={{ width: "300px", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1625.png")}
                        />
                    )}
                </div>
                <p>No existing structures nearby</p>
            </div>
            <h3>0 Sides Blocked (0B)</h3>
            <div className={classes.gridContainer}>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/0a.png")}
                        />
                    </div>
                    <p>No existing structures nearby</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/0b.png")}
                        />
                    </div>
                    <p>Existing structure 1,000mm or more away from structure</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/0c.png")}
                        />
                    </div>
                    <p>Attached side is 22% or less of total perimeter and 2,000mm or less is attached.</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/0d.png")}
                        />
                    </div>
                    <p>Existing patios should not be considered when calculating blocking.</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/0e.png")}
                        />
                    </div>
                    <p>Fences 2,000mm or shorter should not be considered when calculating blocking.</p>
                </div>
            </div>
            <h3>1 Sides Blocked (1B)</h3>
            <div className={classes.gridContainer}>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1a.png")}
                        />
                    </div>
                    <p>Existing structure less than 1,000mm from structure on one side only.</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1b.png")}
                        />
                    </div>
                    <p>
                        Attached side is 22% or less of total perimeter, but more than 2,000mm is attached on one side.
                    </p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1c.png")}
                        />
                    </div>
                    <p>Attached side is more than 22% of total perimeter.</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1d.png")}
                        />
                    </div>
                    <p>Solid walls greater than 1,800mm tall should be considered as blocking.</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1e.png")}
                        />
                    </div>
                    <p>Fences 2,000mm or shorter should not be considered when calculating blocking.</p>
                </div>
            </div>
            <h3>2 Sides Blocked (2B)</h3>
            <div className={classes.gridContainer}>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/2a.png")}
                        />
                    </div>
                    <p>Existing structure is attached on two sides.</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/2b.png")}
                        />
                    </div>
                    <p>Existing structure is less than 1,000mm from structure on two sides</p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/2c.png")}
                        />
                    </div>
                    <p>
                        Attached on two sides, with a third side being less than 22% of total perimeter with 2,000mm or
                        less attached.
                    </p>
                </div>
                <div className={classes.gridItem}>
                    <div style={{ width: 180, height: 140, backgroundColor: "#f2f2f0" }}>
                        <img
                            style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                            alt=""
                            src={BaseURL("images/Blocking-Images/1d.png")}
                        />
                    </div>
                    <p>Solid walls greater than 1,800mm tall should be considered as blocking.</p>
                </div>
            </div>
        </>
    );

    return (
        <div
            className={`${classes.scrollBar} ${width === 0 && classes.hideBar}`}
            style={page === DESIGNER_PAGE ? { top: "0px" } : {}}
        >
            <div style={{ height: height - (page === DESIGNER_PAGE ? 0 : 120) }} className={classes.root}>
                <div className={`${width > 0 ? classes.container : classes.containerClose}`}>
                    <div className={classes.closeButton}>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <h1>Help</h1>
                    {renderHelp()}
                    {open && (
                        <NewWindow>
                            {window.brand === "Fielders" ? (
                                <img
                                    style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                                    alt=""
                                    src={renderImage}
                                />
                            ) : (
                                <img
                                    style={{ width: "100%", height: "undefined", aspectRatio: 1 }}
                                    alt=""
                                    src={renderImage}
                                />
                            )}
                        </NewWindow>
                    )}
                </div>
            </div>
        </div>
    );
}
